export const songKeys = {
  detail: (id: number | string) => ["songs", "detail", id] as const,
  related: (id: number | string) => ["songs", "related", id] as const,
};
